// extracted by mini-css-extract-plugin
export default {"Navigation":"mOldZMDP","list":"robvkNWI","blockItem":"QaIK33fP","item":"iR8VcRwx","textDesktop":"Md5PTls5"};
    if(module.hot) {
      // 1776432162262
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  